import { forwardRef } from "react";
import styled from "styled-components";
import Twitter from "./projects/twitterProject/Twitter";
import Pokemons from "./projects/pokemonsProject/Pokemons";
import Figma from "./projects/figmaProject/Figma";
import Cv from "./projects/CVProject/Cv";
import Dashboard from "./projects/adminDashboard/Dashboard";
import TextAnimation from "../animations/TextAnimateion";
import Appear from "../animations/Appear";
import EcommerceShop from "./projects/ecommerceShop/EcommerceShop";
import HaedlessCMS from "./projects/headlesCMS/HeadlesCMS";

const Projects = forwardRef<HTMLDivElement>((props, ref) => (
  <AboutContainer ref={ref}>
    <TextAnimation>
      <Header>Projects</Header>
    </TextAnimation>
    <AboutText>
      <p>
        You can find some of my projects in my repository on{" "}
        <b>
          {" "}
          <a
            href="https://github.com/Kamildeeal"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
        </b>
        <br />
        <br />
      </p>
      <Appear>
        <HaedlessCMS />
        {/* <Dashboard /> */}
      </Appear>
      <Appear>
        <EcommerceShop />
      </Appear>
      <Appear>
        <Twitter />
      </Appear>
      <Appear>
        <Pokemons />
      </Appear>
      <Appear>
        <Figma />
      </Appear>
      {/* <Stopwatch /> */}
      <Appear>
        <Cv />
      </Appear>
    </AboutText>
  </AboutContainer>
));

export default Projects;
const AboutContainer = styled.div`
  width: 100%;
  overflow-y: auto
  height: auto;
  margin-top: 40px;
  & > h3 {
    color: white;
    font-size: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
    margin-top: 40px;
    margin-bottom: 5px;
    letter-spacing: 3px;
    font-style: oblique;
  }
`;

const Header = styled.h3`
  color: white;
  font-size: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  letter-spacing: 3px;
  font-style: oblique;

  @media (max-width: 460px) {
    margin-top: 10px;
  }
`;

const AboutText = styled.div`
  max-width: 100%;
  margin-right: 16px;
  margin-left: 20px;
  height: auto;
  border-radius: 8px;
  background: rgba(185, 185, 185, 0.44);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
  padding: 15px 15px;

  > p {
    color: rgba(7, 7, 66, 0.89);
    font-weight: bolder;
    font-size: 1.3rem;

    @media (max-width: 460px) {
      font-size: 1rem;
    }

    > b > a {
      letter-spacing: 2px;
      color: black;
      font-weight: bold;
      margin-left: 4px;
      text-decoration: underline !important;
    }
  }
`;
